import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Application } from 'src/app/core/models/application.model';
import { Event } from 'src/app/core/models/event.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { EventService } from 'src/app/core/services/event.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-apply-for-event',
  templateUrl: './apply-for-event.component.html',
  styleUrls: ['./apply-for-event.component.scss']
})
export class ApplyForEventComponent implements OnInit {
  event = new Event();
  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private eventService: EventService,
    private route: ActivatedRoute,
    private router: Router,
    private applicationService: ApplicationService) { }

  ngOnInit(): void {

    if (this.route.snapshot.params.id) {
      this.getEvent(this.route.snapshot.params.id);
    }
  }

  getEvent(id: string){
    this.loadingService.setLoading(true);
    this.eventService.getEventDetailsById(this.route.snapshot.params.id).subscribe(response => {
      if (response.success) {
        this.event = response;
        console.log(this.event);
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  applyForEvent(id: string) {
    let application = new Application();
    application.eventId = this.event.id;
    application.volunteerRoleTypeId = id;
    this.loadingService.setLoading(true);
    this.applicationService.addApplication(application).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı!', 'Başvurunuzu aldık!', 'success');
        this.loadingService.setLoading(false);
        this.getEvent(this.event.id);
      }
      else {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', 'Başvurunuz alınamadı!', 'error');
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  cancelApplication(id: string) {
    this.loadingService.setLoading(true);
    this.applicationService.deleteApplication(id).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı!', 'Başvurunuzu iptal edildi!', 'success');
        this.loadingService.setLoading(false);
        this.getEvent(this.event.id);
      }
      else {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', 'Başvurunuz iptal edilemedi!', 'error');
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

}
